
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { BusinessUnitComponent } from './BusinessUnitSwitch';
export default (ComponentInitializeDispatcher as BusinessUnitComponent).extend({
  name: 'owc-business-unit',
  props: {
    label: {
      type: String,
      required: true,
    },
    iconId: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    target: {
      type: String,
      required: true,
    },
  },
});
